import actions from "./actions";

export default {
  namespaced: true,
  state: {
    currentPageIndex: 0,
    pages: [
      "Поля ввода",
      "MarkDown",
      "Кнопки",
      "Навигация",
      "Компоненты",
      "Таблицы",
      "Макет",
      "Indent",
      "UiKit"
    ]
  },

  getters: {
    currentPageIndex: state => {
      return state.currentPageIndex;
    },

    pages: state => {
      return state.pages;
    }
  },
  mutations: {
    setCurrentPage(state, currentPageIndex) {
      state.currentPageIndex = currentPageIndex;
    }
  },

  actions
};